import { Component, OnInit } from '@angular/core';

import { NotificacaoService } from './notificacao.service';
import { Notificacao } from './notificacao';
import { NotificacaoEnum } from './notificacao.enum';
export class NotificacaoComponent implements OnInit {

  notificacao: Notificacao;
  visivel: Boolean = false;
/**
 * @param {?} notificacaoService
 */
constructor(private notificacaoService: NotificacaoService) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.notificacaoService.notificacaoAdicionada.subscribe((notificacao: Notificacao) => {
        this.notificacao = notificacao;
        this.visivel = true;
         if (this.notificacao.timeout) {
           setTimeout(() => {
             this.visivel = false;
           }, this.notificacao.timeout);
         }
    });
  }
/**
 * @return {?}
 */
tipoAlerta() {
    const /** @type {?} */ tipoNotificacao = NotificacaoEnum[this.notificacao.tipo];
    return `alert-${tipoNotificacao}`;

  }
/**
 * @return {?}
 */
fechar() {
    this.visivel = false;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-notificacao-nota-aluno',
  template: `
    <div class="div-alerta div-alert-fixed" (click)="fechar()">
      <div  *ngIf="visivel" [ngClass]="['alert', tipoAlerta(), 'alert-position']" role="alert">
        <div (click)="fechar()" style="float:right;">x</div>
        <div class="ucs-title" *ngIf="notificacao?.titulo">{{notificacao?.titulo}}</div>
        <div *ngIf="notificacao?.mensagem" class="ucs-msg">
          {{notificacao?.mensagem}}
        </div>
      </div>
    </div>
  `,
  styles: [`
    .div-alert-fixed {
      position: fixed; bottom: 5px; left: 5px;
      z-index: 9999;
    width: 300px;
    }



    .ucs-title {
    font-weight: bold;
    }

    .ucs-icon span {
    vertical-align:middle;
    font-size: 22px;
    top: 2px;
    }

    .ucs-msg {
    word-break: break-all;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NotificacaoService, },
];
}

function NotificacaoComponent_tsickle_Closure_declarations() {
/** @type {?} */
NotificacaoComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotificacaoComponent.ctorParameters;
/** @type {?} */
NotificacaoComponent.prototype.notificacao;
/** @type {?} */
NotificacaoComponent.prototype.visivel;
/** @type {?} */
NotificacaoComponent.prototype.notificacaoService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
